// src/components/Modals/EditFavoriteModal.jsx
import React, { useState, useEffect, useRef } from 'react';

const EditFavoriteModal = ({
  isOpen,
  onClose,
  onBack,
  elevator,
  onSave
}) => {
  const [elevatorName, setElevatorName] = useState('');
  const textRef = useRef(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  useEffect(() => {
    if (isOpen && elevator) {
      setElevatorName(elevator.name);
    }
  }, [isOpen, elevator]);

  useEffect(() => {
    if (isOpen && textRef.current) {
      const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
      const height = textRef.current.clientHeight;
      setIsMultiLine(height > lineHeight * 1.5);
    }
  }, [isOpen]);

  const handleSaveChanges = async () => {
    if (elevatorName.trim() && elevator) {
      await onSave(elevator.regNumber, elevatorName.trim());
      handleModalClose();
    }
  };

  const handleModalClose = () => {
    setElevatorName('');
    onClose();
  };

  const handleModalBack = () => {
    setElevatorName('');
    onBack();
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-[80] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xs mx-auto transform transition-all duration-300 ease-out">
        <div className="p-6 text-center relative">
          <button
            onClick={handleModalClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="w-12 h-12 mx-auto mb-4 flex justify-center items-center">
            <img src="./assets/static/MEL_3.png" className="h-6 w-6" alt="編集アイコン" />
          </div>

          <h3 className="text-lg font-bold text-gray-800">マイエレベータ名の変更</h3>
          <p
            ref={textRef}
            className={`text-sm text-gray-600 mt-2 ${isMultiLine ? 'text-left' : 'text-center'}`}
          >
            新しい名前を入力してください。
          </p>

          <input
            type="text"
            value={elevatorName}
            maxLength={20}
            onChange={(e) => setElevatorName(e.target.value)}
            className="mt-4 w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="エレベータの名前"
          />

          <div className="mt-12 flex gap-4">
            <button
              onClick={handleModalBack}
              className="w-full bg-white border border-gray-200 text-gray-700 font-bold py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors"
            >
              戻る
            </button>
            <button
              onClick={handleSaveChanges}
              className="w-full ux-bg-dark-gray text-white font-bold py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors"
            >
              保存
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFavoriteModal;